module.exports = __webpack_public_path__ + "static/media/collectors choice music.94887dd3.png";